/* ndl-gallery-tabs.js — instant tab filtering on the gallery index.
 *
 * THIS IS AN ENHANCEMENT, NOT THE FEATURE. Every tab is a real page with a real
 * URL (snippets/ndl-gallery-tabs.liquid explains why). This file only makes
 * switching between them feel instant on the index, where all the tiles are
 * already in the DOM. If it fails to load, every tab still works as a link — the
 * search surface never depends on this running.
 *
 * The URL is pushed to the tab's OWN href, so reload / share / back all land on
 * the real server-rendered page. Filtering to a URL that renders something else
 * on reload would be worse than no filtering at all.
 *
 * Only intercepts on the index. On a tab page, clicking another tab is a normal
 * navigation, because that page holds only its own images and has nothing to
 * filter.
 */
(function () {
  'use strict';

  var strip = document.querySelector('[data-ndl-gtabs]');
  var gallery = document.querySelector('.ndl-gallery');
  if (!strip || !gallery) return;

  var tiles = gallery.querySelectorAll('.ndl-gallery__item');
  if (!tiles.length) return;

  // Only the index carries tiles tagged with their tabs. A tab page's tiles have
  // no data-tabs, so there is nothing to filter and we leave the links alone.
  var filterable = false;
  for (var i = 0; i < tiles.length; i++) {
    if (tiles[i].hasAttribute('data-tabs')) { filterable = true; break; }
  }
  if (!filterable) return;

  var head = document.querySelector('.ndl-gallery__head');
  var baseTitle = head ? head.querySelector('h2') : null;
  var baseSub = head ? head.querySelector('p') : null;
  var origTitle = baseTitle ? baseTitle.textContent : '';
  var origSub = baseSub ? baseSub.textContent : '';
  var emptyMsg = null;

  function apply(tab, title, intro) {
    var shown = 0;
    for (var i = 0; i < tiles.length; i++) {
      var t = tiles[i];
      var list = (t.getAttribute('data-tabs') || '').split(' ');
      var on = tab === 'all' || list.indexOf(tab) !== -1;
      t.hidden = !on;
      if (on) shown++;
    }

    // Keep the heading honest about what is on screen. Without this the page
    // says "Inspiration Gallery" while showing only kitchens.
    if (baseTitle) baseTitle.textContent = tab === 'all' ? origTitle : (title || origTitle);
    if (baseSub) baseSub.textContent = tab === 'all' ? origSub : (intro || '');

    var links = strip.querySelectorAll('.ndl-gtabs__tab');
    for (var j = 0; j < links.length; j++) {
      var isOn = links[j].getAttribute('data-tab') === tab;
      links[j].classList.toggle('is-active', isOn);
      if (isOn) links[j].setAttribute('aria-current', 'page');
      else links[j].removeAttribute('aria-current');
    }

    if (!emptyMsg) {
      emptyMsg = document.createElement('p');
      emptyMsg.className = 'ndl-gt__empty';
      emptyMsg.setAttribute('data-ndl-tab-empty', '');
      gallery.appendChild(emptyMsg);
    }
    emptyMsg.textContent = 'No images filed under this tab yet.';
    emptyMsg.hidden = shown > 0;
  }

  strip.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('.ndl-gtabs__tab') : null;
    if (!a || !strip.contains(a)) return;
    // Let modified clicks (new tab, download, middle-click) behave normally.
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;

    var tab = a.getAttribute('data-tab');
    if (!tab) return;
    e.preventDefault();

    apply(tab, a.getAttribute('data-title'), a.getAttribute('data-intro'));

    try {
      history.pushState({ ndlTab: tab }, '', a.getAttribute('href'));
    } catch (err) { /* pushState can throw in sandboxed frames; filtering still worked */ }
  });

  window.addEventListener('popstate', function (e) {
    var tab = (e.state && e.state.ndlTab) || 'all';
    var a = strip.querySelector('[data-tab="' + tab + '"]');
    apply(tab, a && a.getAttribute('data-title'), a && a.getAttribute('data-intro'));
  });
})();
